@if (isLoading) {
  <div>Loading…</div>
} @else if (error) {
  <div class="error">{{ error }}</div>
} @else {
  <h3 class="table-title">Zuletzt generierte Barcodes</h3>
  <table class="custom-table">
    <thead>
    <tr>
      @for (column of columns; track $index) {
        <th [ngClass]="'align-' + column.align">
          <div [ngClass]="'table-head-' + column.align">
            <span>{{ column.label }}</span>
            @if (sortColumn === column.key) {
              <img
                class="active"
                (click)="setSort(column.key)"
                (keyup.enter)="setSort(column.key)"
                (keyup.space)="setSort(column.key)"
                tabindex="0"
                [src]="
                    'assets/filter-' +
                    (sortDirection === SortDirection.ASC ? 'asc' : 'desc') +
                    '.svg'
                  "
                alt="Filter Icon"
              />
            } @else {
              <img
                (click)="setSort(column.key)"
                (keyup.enter)="setSort(column.key)"
                (keyup.space)="setSort(column.key)"
                tabindex="0"
                src="../../../../../assets/filter.svg"
                alt="Filter Icon"
              />
            }
          </div>
        </th>
      }
    </tr>
    </thead>
    <tbody>
      @for (row of rows; track row.lastBarcode) {
        <tr>
          <td class="responsive-cell">
            <div class="cell-styling"><span>{{ primaryLabel(row.primaryCode) }}</span></div>
          </td>
          <td class="responsive-cell">
            <div class="cell-styling"><span>{{ secondaryLabel(row.primaryCode, row.secondaryCode) }}</span></div>
          </td>
          <td class="responsive-cell">
            <div class="cell-styling"><span>{{ row.lastBarcode }}</span></div>
          </td>
          <td class="responsive-cell">
            <span>{{ row.lastGeneratedDate | date:'dd.MM.yyyy, HH:mm' }}</span>
          </td>
        </tr>
      }
    </tbody>
    <tfoot><tr><td colspan="4"></td></tr></tfoot>
  </table>
}
